@if (isVisible()) {
  <div class="tour-prompt" [class.skipped]="isSkipped()">
    <!-- Main Prompt Content -->
    @if (!isSkipped()) {
      <div class="prompt-content">
        <div class="prompt-icon">
          <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <!-- Farm Assistant Robot -->
            <circle cx="32" cy="32" r="28" fill="url(#grad1)" />
            <!-- Body -->
            <ellipse cx="32" cy="38" rx="16" ry="14" fill="#4CAF50" />
            <!-- Overalls -->
            <path d="M20 34 L20 48 Q20 52 24 52 L40 52 Q44 52 44 48 L44 34" fill="#8B4513" />
            <rect x="26" y="34" width="12" height="10" rx="2" fill="#A0522D" />
            <!-- Straw Hat -->
            <ellipse cx="32" cy="18" rx="18" ry="6" fill="#DEB887" />
            <ellipse cx="32" cy="16" rx="12" ry="8" fill="#F5DEB3" />
            <path d="M20 16 Q32 12 44 16" stroke="#8B4513" stroke-width="1.5" fill="none" />
            <!-- Face -->
            <circle cx="32" cy="28" r="10" fill="#FFE4C4" />
            <!-- Eyes -->
            <circle cx="28" cy="26" r="2.5" fill="#333" />
            <circle cx="36" cy="26" r="2.5" fill="#333" />
            <circle cx="29" cy="25" r="1" fill="#FFF" />
            <circle cx="37" cy="25" r="1" fill="#FFF" />
            <!-- Smile -->
            <path d="M28 31 Q32 35 36 31" stroke="#333" stroke-width="1.5" fill="none" stroke-linecap="round" />
            <!-- Cheeks -->
            <circle cx="24" cy="29" r="2" fill="#FFB6C1" opacity="0.6" />
            <circle cx="40" cy="29" r="2" fill="#FFB6C1" opacity="0.6" />
            <!-- Wheat stalk -->
            <g transform="translate(46, 8) rotate(15)">
              <line x1="0" y1="0" x2="0" y2="16" stroke="#DAA520" stroke-width="2" />
              <ellipse cx="-2" cy="2" rx="2" ry="4" fill="#F4A460" />
              <ellipse cx="2" cy="4" rx="2" ry="4" fill="#F4A460" />
              <ellipse cx="-2" cy="6" rx="2" ry="4" fill="#F4A460" />
              <ellipse cx="2" cy="8" rx="2" ry="4" fill="#F4A460" />
            </g>
            <defs>
              <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color:#87CEEB;stop-opacity:1" />
                <stop offset="100%" style="stop-color:#98FB98;stop-opacity:1" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div class="prompt-text">
          <h4 class="prompt-title">{{ 'tour.promptTitle' | translate }}</h4>
          <p class="prompt-subtitle">{{ 'tour.promptSubtitle' | translate }}</p>
        </div>
        <div class="prompt-actions">
          <app-mat3-button variant="outlined" size="sm" [text]="'tour.skipTour' | translate" (buttonClick)="onSkip()">
          </app-mat3-button>
          <app-mat3-button variant="primary" size="sm" beforeIcon="play_arrow" [text]="'tour.continue' | translate"
            (buttonClick)="onStartTour()">
          </app-mat3-button>
        </div>
      </div>
    }

    <!-- Skip Confirmation Message -->
    @if (isSkipped()) {
      <div class="skip-message">
        <mat-icon class="message-icon">chat</mat-icon>
        <p>{{ 'tour.skipMessage' | translate }}</p>
        <app-mat3-button class="close-btn" variant="icon" icon="close" [iconSize]="18" (buttonClick)="onDismiss()">
        </app-mat3-button>
      </div>
    }
  </div>
}